import AccountMenuIcon from "./AccountMenuIcon";
import ArrowDownIcon from "./ArrowDownIcon";
import Camera0Icon from "./Camera0Icon";
import CameraIcon from "./CameraIcon";
import CartMenuIcon from "./CartMenuIcon";
import CartOutlinedIcon from "./CartOutlinedIcon";
import CheckIcon from "./CheckIcon";
import ChevronLeftIcon from "./ChevronLeftIcon";
import ChevronUpIcon from "./ChevronUpIcon";
import CloudIcon from "./CloudIcon";
import CSVIcon from "./CSVIcon";
import CubeFilledIcon from "./CubeFilledIcon";
import DatasetIcon from "./DatasetIcon";
import DismissIcon from "./DismissIcon";
import DownloadIcon from "./DownloadIcon";
import FilterIcon from "./FilterIcon";
import FolderIcon from "./FolderIcon";
import FootIcon from "./FootIcon";
import GeodatabaseIcon from "./GeodatabaseIcon";
import GeojsonIcon from "./GeojsonIcon";
import InfoCircleIcon from "./InfoCircleIcon";
import KMLIcon from "./KMLIcon";
import BasemapIcon from "./BasemapIcon";
import MapIcon from "./MapIcon";
import MapMenuIcon from "./MapMenuIcon";
import MenuIcon from "./MenuIcon";
import MinusIcon from "./MinusIcon";
import NotificationMenuIcon from "./NotificationMenuIcon";
import PlusIcon from "./PlusIcon";
import PolygonDrawIcon from "./PolygonDrawIcon";
import QueryIcon from "./QueryIcon";
import RadaIcon from "./RadaIcon";
import RectangleDrawIcon from "./RectangleDrawIcon";
import SearchIcon from "./SearchIcon";
import ShapeIcon from "./ShapeIcon";
import SimpleSelectIcon from "./SimpleSelectIcon";
import StorageIcon from "./StorageIcon";
import TrashIcon from "./TrashIcon";
import UploadPolygonIcon from "./UploadPolygonIcon";
import ZoomIcon from "./ZoomIcon";
import ImageInfoCloudIcon from "./imageInformationIcons/CloudIcon";
import ImageInfoCreatedIcon from "./imageInformationIcons/CreatedIcon";
import ImageInfoDatetimeIcon from "./imageInformationIcons/DatetimeIcon";
import ImageInfoInstrumentsIcon from "./imageInformationIcons/InstrumentsIcon";
import ImageInfoPlatformIcon from "./imageInformationIcons/PlatformIcon";
import ImageInfoShapeIcon from "./imageInformationIcons/ShapeIcon";
import ImageInfoSunAzimuthIcon from "./imageInformationIcons/SunAzimuthIcon";
import ImageInfoSunElevationIcon from "./imageInformationIcons/SunElevationIcon";
import SettingIcon from "./SettingIcon";
import OrderIcon from "./OrderIcon";
import SendIcon from './SendIcon'
import BackIcon from "./BackIcon";
import NextIcon from "./NextIcon";
import RefreshIcon from "./RefreshIcon";
import FilterFooterIcon from "./FilterFooterIcon";
import LayerIcon from "./LayerIcon";
import DrawRectangleIcon from "./DrawRectangleIcon";
import FooterIcon from "./FooterIcon";
import SearchImageIcon from "./SearchImageIcon";
import UploadIcon from "./Upload";
import DeleteIcon from "./DeleteIcon";
import ApplyIcon from "./ApplyIcon";
import MoreIcon from "./MoreIcon";
import DashboardTotalOrderIcon from "./DashboardTotalOrder";
import DashboardPendingIcon from "./DashboardPending";
import DashboardCoverIcon from "./DashboardCover";
import DashboardStorageIcon from "./DashboardStorage";
import ExploreArchiveIcon from "./ExploreArchive";
import ExploreTaskingIcon from "./ExploreTasking";
import BaseMapIcon from "./BaseMap";
import EyesIcon from "./Eyes";
import PantoIcon from "./Panto";
import DatetimeIcon from "./Datetime";
import GsdIcon from "./GSD";
import DecreasingIcon from "./Decreasing";
import AscendingIcon from "./Asending";
import MarkReadAllIcon from "./MarkReadAll";
import InfoCircleIconAlert from "./InfoCircleIconAlert";

const CommonIcons = {
  AccountMenuIcon,
  CartMenuIcon,
  MapMenuIcon,
  MenuIcon,
  NotificationMenuIcon,
  PolygonDrawIcon,
  RectangleDrawIcon,
  UploadPolygonIcon,
  BasemapIcon,
  MinusIcon,
  PlusIcon,
  RadaIcon,
  ZoomIcon,
  FilterIcon,
  SearchIcon,
  ArrowDownIcon,
  ChevronUpIcon,
  CubeFilledIcon,
  DatasetIcon,
  StorageIcon,
  DismissIcon,
  DownloadIcon,
  FolderIcon,
  InfoCircleIcon,
  TrashIcon,
  CameraIcon,
  Camera0Icon,
  CartOutlinedIcon,
  CloudIcon,
  FootIcon,
  MapIcon,
  CSVIcon,
  GeodatabaseIcon,
  GeojsonIcon,
  KMLIcon,
  QueryIcon,
  ShapeIcon,
  CheckIcon,
  ChevronLeftIcon,
  SimpleSelectIcon,
  ImageInfoCloudIcon,
  ImageInfoCreatedIcon,
  ImageInfoDatetimeIcon,
  ImageInfoInstrumentsIcon,
  ImageInfoPlatformIcon,
  ImageInfoShapeIcon,
  ImageInfoSunAzimuthIcon,
  ImageInfoSunElevationIcon,
  SettingIcon,
  OrderIcon,
  SendIcon,
  BackIcon,
  NextIcon,
  RefreshIcon,
  FilterFooterIcon,
  LayerIcon,
  DrawRectangleIcon,
  FooterIcon,
  SearchImageIcon,
  UploadIcon,
  DeleteIcon,
  ApplyIcon,
  MoreIcon,
  DashboardTotalOrderIcon,
  DashboardPendingIcon,
  DashboardCoverIcon,
  DashboardStorageIcon,
  ExploreArchiveIcon,
  ExploreTaskingIcon,
  BaseMapIcon,
  EyesIcon,
  PantoIcon,
  DatetimeIcon,
  GsdIcon,
  DecreasingIcon,
  AscendingIcon,
  MarkReadAllIcon,
  InfoCircleIconAlert
};

export default CommonIcons;
